module.exports = __webpack_public_path__ + "img/popup_edit_sigama.048776a5.svg";